export default "__VITE_ASSET__BBqmJW0C__"